var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 8c0 2.313 1.38 4.312 3.382 5.259L2.52 5.622A5.7 5.7 0 0 0 2 8m10.05-.295c0-.722-.266-1.222-.495-1.612c-.304-.482-.589-.889-.589-1.371c0-.537.418-1.037 1.008-1.037q.04.001.078.005A6.06 6.06 0 0 0 8 2.156A6.04 6.04 0 0 0 2.987 4.79c.141.004.274.007.386.007c.627 0 1.599-.074 1.599-.074c.323-.018.361.444.038.482c0 0-.325.037-.687.055l2.185 6.33l1.313-3.835l-.935-2.495a12 12 0 0 1-.629-.055c-.323-.019-.285-.5.038-.482c0 0 .991.074 1.58.074c.627 0 1.599-.074 1.599-.074c.323-.018.362.444.038.482c0 0-.326.037-.687.055l2.168 6.282l.599-1.947c.259-.809.457-1.389.457-1.889zm-3.945.806l-1.8 5.095a6.15 6.15 0 0 0 3.687-.093a1 1 0 0 1-.043-.081zm5.16-3.315q.04.279.04.601c0 .593-.114 1.259-.456 2.093l-1.833 5.16c1.784-1.013 2.983-2.895 2.983-5.051a5.7 5.7 0 0 0-.735-2.803zM8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpress);
export default __webpack_public_path__ + "static/media/wordpress.d7e01a74f8804bc1d11fe66c10936883.svg";
export { ForwardRef as ReactComponent };